import styled from "styled-components";

const CarSection = styled.div`
  background: var(--car-unSelected-bg);
  padding: 15px 5px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  font-family: "latobold";
  cursor: pointer;

  h3 {
    font-size: 40px;
    line-height: 48px;
    color: #000000;
  }
  span {
    font-size: 9px;
    line-height: 11px;
    text-align: center;
    color: #636f7c;
  }
`;
const InfoSection = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 10px;
  width: 100%;
  justify-content: space-between;
  cursor: pointer;

  .msg-section {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    padding: 10px 0;
    flex: 1;
    button {
      font-size: 13px;
      line-height: 150.5%;
      color: #1d1d1d;
      display: inline-flex;
      align-items: center;
      gap: 10px;
      border: 1px solid #1d1d1d;
      background-color: transparent;
      border-radius: 15px;
      padding: 5px;
      cursor: pointer;
    }
    .number-dig {
      font-size: 22px;
      line-height: 26px;
      color: #af815c;
      font-family: "latobold";
    }
    .top-icon {
      display: flex;
      align-items: center;
      gap: 6px;
      .battery-icon {
        margin-left: 15px;
      }
    }
  }
  .time-section {
    border-top: 1px solid #e5e5e5;
    padding: 8px 0 13px;
    display: flex;
    align-items: center;
    gap: 15px;
    p {
      font-size: 12px;
      line-height: 150.5%;
      color: #000;
    }
    .date-info {
      color: #0009;
      display: flex;
      align-items: center;
      gap: 5px;
    }
  }
`;
const CardWrapper = styled.div`
  background: #ffffff;
  box-shadow: 0px 4px 15px #0000001a;
  display: flex;
  min-height: 175px;

  &.list-view {
    margin-bottom: 10px;
    background: var(--inner-section-bg);
    box-shadow: 0px 4px 15px rgb(0 0 0 / 10%);
    display: flex;
    width: 100%;
    border: 1px solid #999999;
    border-radius: 6px;
    min-height: auto;
    ${CarSection} {
      flex-direction: row;
      padding: 6px 17px 6px 10px;
      border-left: 5px solid transparent;
      border-right: none;
      h3 {
        font-size: 20px;
        margin-right: 5px;
        line-height: normal;
        min-width: 35px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    ${InfoSection} {
      .msg-section {
        align-items: center;
        button {
          width: 30px;
          height: 26px;
          align-items: center;
          display: flex;
          padding: 0;
          justify-content: center;
          background: linear-gradient(
            180deg,
            #d9d9d9 0%,
            rgba(217, 217, 217, 0) 100%
          );
          border: 1px solid #636f7c;
          border-radius: 6px;
        }
        .top-icon {
          .battery-icon {
            width: 25px;
          }
        }
      }
    }
    .card-view {
      display: none;
    }
    .list-view {
      display: inline-flex;
    }
  }
  &.card-view {
    .card-view {
      display: inline-flex;
    }
    .list-view {
      display: none;
    }
  }
`;

export { CardWrapper, CarSection, InfoSection };
